import React from 'react';
import Lottie from 'react-lottie';
import data from '~/assets/animations/data.json';

import { Container } from './styles';

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: data,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};

export default function Load() {
  return (
    <Container>
      <Lottie options={defaultOptions} height={150} width={150} />
    </Container>
  );
}
